export const API_URL = "https://lottostockapi.renny.co.th/";
export const imageUrl = "https://lottostockapi.renny.co.th/";
export const TOKEN_KEY = "user";

// export const API_URL = "https://lottostockapi-dv.renny.co.th/";
// export const imageUrl = "https://lottostockapi-dv.renny.co.th/";
